import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  removeCards: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/remove-card/`,
  },
  updateCard: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/update-card/`,
  },
  cancelSubscription: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/change-status-subscription/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const removeCards = () => {
  return resource.removeCards()
}

const updateCard = (payload) => {
  return resource.updateCard(payload)
}

const cancelSubscription = (payload) => {
  return resource.cancelSubscription(payload)
}

export default {
  initResource,
  removeCards,
  updateCard,
  cancelSubscription,
}
